export function mediaTypeLabel(type) {
  if (type === "video") return "Video";
  if (type === "document") return "Document";
  if (type === "audio") return "Audio";
  return "Photo";
}

export function entryTypeLabel(type) {
  if (type === "milestone") return "Milestone";
  if (type === "trip") return "Trip";
  if (type === "appointment") return "Appointment";
  return "Memory";
}

export function formatCount(count) {
  if (count === 1) return "1 photo";
  return `${count} photos`;
}

export function mediaSrc(item, fullSize = false) {
  return fullSize
    ? item?.displayUrl || item?.url || item?.thumbnailUrl || ""
    : item?.thumbnailUrl || item?.displayUrl || item?.url || "";
}

const DAY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

function localDayKey(value) {
  const date = value instanceof Date ? value : new Date(value);
  if (!value || Number.isNaN(date.getTime())) return "";
  return [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, "0"),
    String(date.getDate()).padStart(2, "0"),
  ].join("-");
}

/** Like the app's timeline header: Today, Yesterday, or "Sep 6, 2026". */
export function formatEntryDay(entry, now = new Date()) {
  // `day` is the family's own calendar day; `date` is a fallback for older responses.
  const day = DAY_PATTERN.test(entry?.day || "") ? entry.day : localDayKey(entry?.date);
  if (!day) return "";
  if (day === localDayKey(now)) return "Today";
  const yesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
  if (day === localDayKey(yesterday)) return "Yesterday";
  const [year, month, date] = day.split("-").map(Number);
  return new Intl.DateTimeFormat(undefined, {
    month: "short", day: "numeric", year: "numeric", timeZone: "UTC",
  }).format(new Date(Date.UTC(year, month - 1, date)));
}

/** Matches the app's attachment fallback names. */
export function recordingName(item, ordinal, total) {
  const name = typeof item?.name === "string" ? item.name.trim() : "";
  if (name) return name;
  return total > 1 ? `Recording ${ordinal}` : "Recording";
}

export function attachmentSummary(media = []) {
  const recordings = media.filter((item) => item?.type === "audio").length;
  const documents = media.filter((item) => item?.type === "document").length;
  return [
    recordings ? `${recordings} ${recordings === 1 ? "recording" : "recordings"}` : "",
    documents ? `${documents} ${documents === 1 ? "document" : "documents"}` : "",
  ].filter(Boolean).join(" · ");
}
